import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import SingleProduct from '../components/SingleProduct';
import IssuesDisplay from '../components/IssuesDisplay';

const Products = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleCanvas = () => {
        setIsOpen(!isOpen);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setIsOpen(true);
    };

    return (
        <div className='d-flex w-100 overflow-hidden'>
            <div className='asidebar'>
                <Sidebar />
            </div>
            <div className='main-content'>
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <h2>All Products</h2>
                    <div className='d-flex align-items-center justify-content-end'>
                        <div className="">
                            <input
                                type="text"
                                className="form-control w-300px rounded-50 ps-3" style={{ height: '50px' }}
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                </div>

                <IssuesDisplay searchQuery={searchQuery} onProductClick={handleProductClick} />

                <Offcanvas isOpen={isOpen} toggle={toggleCanvas} className="custom-canvas-width" direction='end'>
                    <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCanvas}>
                        <span className='font-weight-bold'>{selectedProduct?.title || 'Product Details'}</span>
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <SingleProduct product={selectedProduct} />
                    </OffcanvasBody>
                </Offcanvas>
            </div>
        </div>
    );
};

export default Products;
